module.exports = __webpack_public_path__ + "Neoway-vetores.acf94c1f.svg";